import { getMonth, getYear, isValid } from "date-fns";
import { dateFormat, validateDate } from "~/shared/lib/DateFormat/dateFormat";
import { IAppealPeriodParams } from "~/entity/Appeals/model/schema";

export interface IAppealAdminControlFormValues {
  period?: {
    from?: Date;
    to?: Date;
  };
  date?: Date;
}

export const toAppealPeriodRequest = (
  values: IAppealAdminControlFormValues
): IAppealPeriodParams | null => {
  const from = values?.period?.from;
  const to = values?.period?.to;
  const decisionDate = values?.date;

  if (!from || !to || !decisionDate) return null;
  // Поддерживаем Date | string внутри формы и не даём уйти невалидным значениям
  if (!validateDate(from) || !validateDate(to) || !validateDate(decisionDate))
    return null;

  const fromDate = new Date(from as any);
  const toDate = new Date(to as any);
  const decision = new Date(decisionDate as any);
  if (!isValid(fromDate) || !isValid(toDate) || !isValid(decision)) return null;

  // year/month берём от периода (startDate), а не от текущей даты
  const year = getYear(fromDate);
  const month = getMonth(fromDate) + 1;
  if (!Number.isFinite(year) || !Number.isFinite(month)) return null;

  const startDate = dateFormat(fromDate, { type: "date-special" });
  const endDate = dateFormat(toDate, { type: "date-special" });
  const decisionDateISO = dateFormat(decision, { type: "date-special" });
  if (!startDate || !endDate || !decisionDateISO) return null;

  return {
    year,
    month,
    startDate,
    endDate,
    decisionDate: decisionDateISO,
  };
};

export const isSameAppealPeriodRequest = (
  a: IAppealPeriodParams | null | undefined,
  b: IAppealPeriodParams | null | undefined
): boolean => {
  if (!a && !b) return true;
  if (!a || !b) return false;

  return (
    a.year === b.year &&
    a.month === b.month &&
    a.startDate === b.startDate &&
    a.endDate === b.endDate &&
    a.decisionDate === b.decisionDate
  );
};
